export const HaptikConfig = ['/','/rent','/buy','/listing','/search/results','/products/[slug]'];
